import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

export default function PaymentResult() {
  const [params] = useSearchParams();
  const tx = params.get("tx");
  const cancelled = params.get("cancelled") ? 1 : 0;
  const [status, setStatus] = useState("pending");

  useEffect(() => {
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/billing/status/${tx}`, { params: { cancelled } });
        setStatus(data.status);
        if (data.status === "pending" && tries++ < 15) timer = setTimeout(poll, 2500);
      } catch { setStatus("error"); }
    };
    if (tx) poll();
    return () => clearTimeout(timer);
  }, [tx, cancelled]);

  const view = {
    pending: [Loader2, "Confirming payment…", "text-amber-400 animate-spin", "We're checking with the payment provider."],
    paid: [CheckCircle2, "Payment received", "text-emerald-400", "Your membership is active. A receipt is available in Membership."],
    failed: [XCircle, "Payment not completed", "text-red-400", "No charge was made. You can retry from your Membership page."],
    error: [XCircle, "Couldn't verify payment", "text-red-400", "Please check your Membership page shortly."],
  }[status];
  const [Icon, title, cls, sub] = view;

  return (
    <div className="max-w-md mx-auto text-center py-20 fade-up" data-testid="payment-result">
      <Icon size={56} className={`mx-auto ${cls}`} />
      <h1 className="text-4xl font-bold uppercase mt-6" data-testid="payment-result-status">{title}</h1>
      <p className="text-slate-400 mt-2">{sub}</p>
      <Button asChild className="mt-8" data-testid="payment-result-back-btn"><Link to="/app/billing">Go to Membership</Link></Button>
    </div>
  );
}
